import React, { Component } from 'react'
import { Field } from 'redux-form'
import Radio from 'components/Input/Radio'
import Button from 'components/Button'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'

export default class NumbersProductSelectStep extends Component {
  render() {
    const { prev, numberType } = this.props

    return (
      <div>
        <div className={cn(sText.descrip3, sMarg.mb30)}>
          So would you like a number with that? Pickle can provide you with a Simply Awesome Virtual
          Number, or if you already have one Great, we can work with that too.
        </div>

        <Field
          label="I want a new number."
          component={Radio}
          name="isNewNumber"
          radioValue
          style={{ marginBottom: '15px' }}
        />
        <Field
          label="I already have a number."
          component={Radio}
          name="isNewNumber"
          radioValue={false}
        />
        <div
          className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
          style={{ marginTop: '40px' }}
        >
          <Button color="tertiary" type="submit">
            Next
          </Button>
          <br />
          <br />
          <Button plain onClick={prev}>
            Back
          </Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersProductSelectStep/NumbersProductSelectStep.jsx